import { render, staticRenderFns } from "./dormitory-detail.vue?vue&type=template&id=952ef100"
import script from "./dormitory-detail.vue?vue&type=script&lang=js"
export * from "./dormitory-detail.vue?vue&type=script&lang=js"
import style0 from "./dormitory-detail.vue?vue&type=style&index=0&id=952ef100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports